import { round } from "mathjs";
import type { CalcOptions, NumberMatrix3D } from "../algorithm.types";

type CalculateAnnualCurtailmentParams = {
  calcOptions: Pick<
    CalcOptions,
    "noOfTechs" | "noOfTimeSlots" | "noOfDayTypes" | "dayYearPercent"
  >;
  dayChartData: NumberMatrix3D;
};

export default function calculateAnnualCurtailment({
  calcOptions,
  dayChartData,
}: CalculateAnnualCurtailmentParams): number {
  const { noOfTechs, noOfTimeSlots, noOfDayTypes } = calcOptions;
  let annualCurtailment = 0;
  const curtailment = noOfTechs;

  for (let i = 0; i < noOfDayTypes - 1; i++) {
    let dayTotalCurtailment = 0;
    for (let j = 0; j < noOfTimeSlots; j++) {
      dayTotalCurtailment += dayChartData[i][curtailment][j];
      annualCurtailment +=
        dayChartData[i][curtailment][j] * calcOptions.dayYearPercent[i];
    }

    dayTotalCurtailment +=
      ((dayTotalCurtailment / noOfTimeSlots) *
        calcOptions.dayYearPercent[i] *
        8760) /
      1000;
  }

  return round(annualCurtailment, 2);
}
